import React, { Fragment } from 'react';
import { Col, Form } from 'react-bootstrap';
import CrudSimpleForm from '../../../components/Systema/Crud/CrudSimpleForm';
import Input from '../../../components/Input';
import schema from './schema';
import config from '../../../config';
import service from './service';

const CHANNEL_OPTIONS = [
  { value: 'all', label: 'Todos' },
  { value: 'SiorconpAPI', label: 'Siorconp' },
  { value: 'SGRH_API', label: 'SGRH' },
];

const SEVERITY_OPTIONS = [
  { value: 'INFO', label: 'Informação' },
  { value: 'CRITICAL', label: 'Crítica' },
  { value: 'WARNING', label: 'Aviso' },
];

export default function CadastroNotificacaoForm({ match, returnUrl }) {
  const updateId = match && match.params && match.params.updateId;

  function handleModelChange(handleChange) {
    return (event) => {
      const model = event && event.target ? event.target.value : null;

      handleChange({
        target: {
          id: 'modelo',
          value: model,
        },
      });

      if (!model) return;

      handleChange({
        target: {
          id: 'title',
          value: model.title || '',
        },
      });

      handleChange({
        target: {
          id: 'body',
          value: model.body || '',
        },
      });

      handleChange({
        target: {
          id: 'severity',
          value: model.severity || 'INFO',
        },
      });
    };
  }

  function beforeSubmit(formData) {
    delete formData.modelo;
  }

  return (
    <CrudSimpleForm
      updateId={updateId}
      validationSchema={schema}
      service={service}
      returnUrl={returnUrl}
      beforeSubmit={beforeSubmit}
    >
      {({ handleChange, values, errors }) => (
        <Fragment>
          <Form.Row>
            <Form.Group as={Col} xs={12} lg={6}>
              <Form.Label>Cliente</Form.Label>
              <Input.AsyncSelect
                id='cliente'
                value={values.cliente}
                onChange={handleChange}
                path={`${config.api_path}/v1/transparencia/clienteglobal`}
                // eslint-disable-next-line no-template-curly-in-string
                label={'${nome}'}
                rowKey='id'
                nullable
                placeholder='Selecione um cliente ou deixe em branco para todos'
              />
              <Form.Text className='text-muted'>
                Em branco, a notificação vale para todos os clientes.
              </Form.Text>
            </Form.Group>
          </Form.Row>

          <Form.Row>
            <Form.Group as={Col} xs={12}>
              <Form.Label>Modelo de Notificação</Form.Label>
              <Input.AsyncSelect
                id='modelo'
                value={values.modelo}
                onChange={handleModelChange(handleChange)}
                path={`${config.api_path}/v1/global/notification_model`}
                // eslint-disable-next-line no-template-curly-in-string
                label={'${title}'}
                rowKey='id'
                nullable
                placeholder='Selecione um modelo de notificação'
              />
              <Form.Control.Feedback type='invalid'>
                {errors.modelo}
              </Form.Control.Feedback>
            </Form.Group>
          </Form.Row>

          <Form.Row>
            <Form.Group as={Col} xs={12}>
              <Form.Label>Título da Notificação</Form.Label>
              <Input.Text
                id='title'
                value={values.title}
                onChange={handleChange}
                isInvalid={!!errors.title}
                placeholder='Digite o título da notificação'
              />
              <Form.Control.Feedback type='invalid'>
                {errors.title}
              </Form.Control.Feedback>
            </Form.Group>
          </Form.Row>

          <Form.Row>
            <Form.Group as={Col} xs={12}>
              <Form.Label>Texto da Notificação</Form.Label>
              <Form.Control
                as='textarea'
                id='body'
                rows={4}
                value={values.body || ''}
                onChange={handleChange}
                isInvalid={!!errors.body}
                placeholder='Digite o conteúdo da notificação.'
              />
              <Form.Control.Feedback type='invalid'>
                {errors.body}
              </Form.Control.Feedback>
            </Form.Group>
          </Form.Row>

          <Form.Row>
            <Form.Group as={Col} xs={12} md={4} lg={3}>
              <Form.Label>Canal de Comunicação</Form.Label>
              <Form.Control
                as='select'
                id='channel'
                value={values.channel || ''}
                onChange={handleChange}
                isInvalid={!!errors.channel}
              >
                {CHANNEL_OPTIONS.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Control>
              <Form.Control.Feedback type='invalid'>
                {errors.channel}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} xs={12} md={4} lg={3}>
              <Form.Label>Tipo</Form.Label>
              <Form.Control
                as='select'
                id='severity'
                value={values.severity || ''}
                onChange={handleChange}
                isInvalid={!!errors.severity}
              >
                {SEVERITY_OPTIONS.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Control>
              <Form.Control.Feedback type='invalid'>
                {errors.severity}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} xs={12} md={4} lg={6}>
              <Form.Label>Data de validade</Form.Label>
              <Input.Date
                id="expiresAt"
                value={values.expiresAt}
                onChange={handleChange}
              />
            </Form.Group>

          </Form.Row>
        </Fragment>
      )}
    </CrudSimpleForm>
  );
}
